module.exports = __webpack_public_path__ + "media/synonym.9048bfc3.mp3";